import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';
import getCRUDSagas from '../../utils/redux/getCRUDSagas';
import { initialState } from '../../utils/redux/commonActionHandlers';
import Api from '../../utils/Api';


const constantsPrefix = 'VESSEL_TYPES';
const statePropName = 'vesselTypes';
const formStatePropName = 'vesselTypes';
const mainPageUrl = '/vessel-types';

const constants = getConstantsByFeatureName(constantsPrefix);
const actions = getActionCreators(constants);
const actionHandlers = getActionHandlers(constants);
const reducer = buildReducer(initialState, actionHandlers);
const selector = getSelectorByFeatureName(statePropName);

const sagas = getCRUDSagas(
  mainPageUrl,
  Api.vesselTypes,
  actions,
  constants,
  formStatePropName,
  statePropName,
  { itemName: 'Vessel type' },
);

export { constants, actions, reducer, selector, sagas };
